/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <img
    width={width}
    height={height}
    src="/assets/icons/contact_mail_icon.svg"
    alt="icons"
  />
);

export default SvgComponent;
